import React from 'react';
import AuthPage from '../components/AuthPage';

const Login = () => <AuthPage mode="login" />;

export default Login;
